export default __webpack_public_path__ + "static/butter-yellow-banner-mobile-c1a01f8978c1a5d7fc7ee47c9c7797d8.webp";